import { createInMemoryAtom } from '@exodus/atoms';
const createExchangeStatusAtom = () => createInMemoryAtom({ defaultValue: {} });
export default createExchangeStatusAtom;
